import cx from 'classnames';
import { PropsWithChildren } from 'react';

/** Figma 6032:263878 — 18px chevron + 2px gap + 8px row pl + 12px (half of 24px logomark). */
const TREE_SPINE_LEFT = 'left-[40px]';

type WorkspaceSubTreeProps = {
  childCount: number;
};

const WorkspaceSubTree = ({ childCount, children }: PropsWithChildren<WorkspaceSubTreeProps>) => {
  if (!childCount) return null;

  return (
    <div className="relative">
      <div className={cx('pointer-events-none absolute bottom-4 top-0 w-px bg-gray-30', TREE_SPINE_LEFT)} aria-hidden />
      <div className="flex flex-col">{children}</div>
    </div>
  );
};

type WorkspaceSubTreeItemProps = {
  isLast: boolean;
};

const WorkspaceSubTreeItem = ({ isLast, children }: PropsWithChildren<WorkspaceSubTreeItemProps>) => (
  <div className={cx('relative pl-[42px]', { 'pb-0': isLast })}>
    <div
      className={cx(
        'pointer-events-none absolute top-4 h-3 w-3 border-b border-l border-gray-30 rounded-bl-md',
        TREE_SPINE_LEFT
      )}
      aria-hidden
    />
    {children}
  </div>
);

export const WorkspaceSubTreeLines = { Root: WorkspaceSubTree, Item: WorkspaceSubTreeItem };
